import React from "react";
import "./RdoColunaSkeleton.css";

export function RdoCalendarioSkeleton() {
  return (
    <div className="rdo-col-skeleton rdo-col-skeleton--calendario">
      <div className="rdo-col-skeleton__header">
        <span className="rdo-col-skeleton__pill rdo-col-skeleton__pill--sm" />
        <span className="rdo-col-skeleton__pill rdo-col-skeleton__pill--md" />
        <span className="rdo-col-skeleton__pill rdo-col-skeleton__pill--sm" />
      </div>
      <div className="rdo-col-skeleton__semana">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className="rdo-col-skeleton__dia-label" />
        ))}
      </div>
      <div className="rdo-col-skeleton__grid">
        {Array.from({ length: 25}).map((_, i) => (
          <span key={i} className="rdo-col-skeleton__dia" />
        ))}
      </div>
    </div>
  );
}

export function RdoNotasSkeleton({ itens = 3 }) {
  return (
    <div className="rdo-col-skeleton rdo-col-skeleton--notas">
      {Array.from({ length: itens }).map((_, i) => (
        <div key={i} className="rdo-col-skeleton__card">
          <div className="rdo-col-skeleton__mini-cal" />
          <div className="rdo-col-skeleton__card-info">
            <span className="rdo-col-skeleton__pill rdo-col-skeleton__pill--tag" />
            <span className="rdo-col-skeleton__pill rdo-col-skeleton__pill--lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function RdoColunaSkeleton() {
  return (
    <div className="rdo-calendario-fixo">
      <RdoCalendarioSkeleton />
      <RdoNotasSkeleton />
    </div>
  );
}